import { FC, useState } from 'react'
import { IShippingCarrierForm } from '../../api/shippingCarrier.api'
import { useHandleField } from '../../hooks/useHandleField'
import { IShippingCarrier } from '../../model/IShippingCarrier'
import Button from '../form/Button'
import Input from '../form/Input'

const emptyState: IShippingCarrierForm = {
  name: '',
  url: '',
  trackingUrl: '',
  email: '',
  phone: '',
  visible: true,
}

const ShippingCarrierForm: FC<{
  carrier?: IShippingCarrier | null
  loading?: boolean
  onSubmit: (state: IShippingCarrierForm) => void
}> = ({ carrier, loading, onSubmit }) => {
  const [state, setState] = useState<IShippingCarrierForm>(
    carrier
      ? {
          name: carrier.name ?? '',
          url: carrier.url ?? '',
          trackingUrl: carrier.trackingUrl ?? '',
          email: carrier.email ?? '',
          phone: carrier.phone ?? '',
          visible: carrier.visible ?? true,
        }
      : emptyState,
  )
  const handle = useHandleField(setState)
  const [error, setError] = useState<string>('')

  const handleSubmit = () => {
    if (!state.name?.trim()) {
      setError('Name is required')
      return
    }
    setError('')
    onSubmit(state)
  }

  return (
    <div className='w-full grid grid-cols-12 gap-x-5 gap-y-6'>
      <Input
        label='Name'
        name='name'
        value={state.name}
        handle={handle('name')}
        error={error}
        disabled={loading}
        className='col-span-12'
      />
      <Input
        label='URL'
        name='url'
        value={state.url}
        handle={handle('url')}
        disabled={loading}
        className='col-span-6'
      />
      <Input
        label='Tracking URL'
        name='trackingUrl'
        value={state.trackingUrl}
        handle={handle('trackingUrl')}
        disabled={loading}
        className='col-span-6'
      />
      <Input
        label='Email'
        type='email'
        name='email'
        value={state.email}
        handle={handle('email')}
        disabled={loading}
        className='col-span-6'
      />
      <Input
        label='Phone'
        name='phone'
        value={state.phone}
        handle={handle('phone')}
        disabled={loading}
        className='col-span-6'
      />
      <Input
        label='Visible'
        name='visible'
        value={String(state.visible)}
        options={[
          { title: 'Yes', value: 'true' },
          { title: 'No', value: 'false' },
        ]}
        handle={(e) =>
          setState((prev) => ({
            ...prev,
            visible: (e as React.ChangeEvent<HTMLInputElement>)?.target?.value === 'true',
          }))
        }
        disabled={loading}
        className='col-span-6'
      />
      <div className='col-span-12 flex justify-end gap-3 mt-2'>
        <Button isNotFullWidth type='submit' disabled={loading} onClick={handleSubmit}>
          {carrier ? 'Save' : 'Create'}
        </Button>
      </div>
    </div>
  )
}

export default ShippingCarrierForm
